import Component from '../Component';

const WP_ServerSideRender = wp.serverSideRender;

export default class ServerSideRender extends Component {
  render() {
    if (this.isView()) return null;

    return (
      <WP_ServerSideRender
        block={this.props.block || this.props.context.name}
        attributes={this.props.attributes || null}
      />
    );
  }
}
